module.exports = __webpack_public_path__ + "static/img/homeBg.452743e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/homeBg.jpg
// module id = KU81
// module chunks = 1